<template>
    <div class="relative flex flex-col min-h-screen bg-gray-50">
        <div class="window-drag-zone fixed top-0 inset-x-0 h-7"></div>

        <div class="flex flex-grow py-10 px-4 sm:px-6 lg:px-8">
            <div class="max-w-5xl w-full mx-auto">
                <slot />
            </div>
        </div>
        <div class="flex flex-shrink-0 items-center justify-center p-4">
            <a href="https://samuliban.com" target="_blank" class="text-xs text-gray-500 hover:text-gray-900 transition-colors">
                &copy; SAMU Liban {{ (new Date).getFullYear() }}
            </a>
        </div>
    </div>
</template>
